import React from 'react'
import { LanguageSelector } from '@barracuda-internal/bds-core-v2'

import { useFormatMessage } from 'lib/localization'
import { useLanguageMenuDialogLogic } from 'components/libs/dialog/languageMenu/useLanguageMenuDialogLogic'

export interface LanguageMenuFormProps {
  onClose: () => void
}

const BASE_I18N_KEY = 'ess.logoutmenu'
const BASE_I18N_DIALOG_KEY = 'ess.dialog'

const LanguageMenuDialog: React.FC<LanguageMenuFormProps> = ({ onClose }: LanguageMenuFormProps) => {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const dialogFormatMessage = useFormatMessage(BASE_I18N_DIALOG_KEY)
  const { selectedLanguage, handleSelectLanguage, availableLanguages } = useLanguageMenuDialogLogic()

  return (
    <LanguageSelector
      open
      handleClose={onClose}
      currentLanguageCode={selectedLanguage}
      languages={availableLanguages}
      onSelectLanguage={handleSelectLanguage}
      titleText={formatMessage('language_title')}
      applyText={dialogFormatMessage('okay')}
      cancelText={dialogFormatMessage('cancel')}
    />
  )
}

export default LanguageMenuDialog
